export default __webpack_public_path__ + "partner_132c8af5.png";